import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M.264 1.324a.75.75 0 0 1 1.06-1.06l2.629 2.628C4.86 2.393 5.893 2.04 7 2.04c1.532 0 2.92.676 4.035 1.48 1.118.805 2.003 1.769 2.539 2.416l.004.006c.24.298.366.675.366 1.058s-.126.76-.366 1.058l-.004.006a14.5 14.5 0 0 1-2.249 2.2l2.411 2.412a.75.75 0 1 1-1.06 1.06zm8.753 6.632a2.232 2.232 0 0 0-2.974-2.974zm-8.59-2.02c.319-.386.762-.884 1.305-1.394l7.104 7.104A5.7 5.7 0 0 1 7 11.96c-1.532 0-2.92-.676-4.035-1.48C1.847 9.676.962 8.712.426 8.065l-.004-.006A1.7 1.7 0 0 1 .056 7c0-.383.126-.76.366-1.058l.004-.006Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Hide = { render };
export {
  Hide as default,
  render
};
//# sourceMappingURL=Hide.svg.js.map
